// toursData.js
import scrollS1 from "../assets/images/scroll-s-1.jpg";
import scrollS2 from "../assets/images/scroll-s-2.jpg";
import scrollS3 from "../assets/images/scroll-s-3.jpg";
import scrollS4 from "../assets/images/scroll-s-4.jpg";
import scrollS5 from "../assets/images/scroll-s-5.jpg";
import scrollS6 from "../assets/images/scroll-s-6.jpg";

const makeSlug = (title) =>
  title.toLowerCase().replace(/&/g, "and").replace(/\s+/g, "-");

export const slideAllCategoryData = [
  {
    title: "All Category",
    img: scrollS6,
    rating: "4.9 (523)",
    banner: "Best of Switzerland & Italy with FREE Excursion to Mount Titlis",
    packages: ["European Marvels", "Philippines Manila", "Dubai Explorer"],
  },
  {
    title: "Tickets",
    img: scrollS1,
    rating: "4.9 (523)",
    banner: "Best of Switzerland & Italy with FREE Excursion to Mount Titlis",
    packages: ["European Marvels", "Philippines Manila", "Dubai Explorer"],
  },
  {
    title: "Tours",
    img: scrollS2,
    rating: "4.8 (410)",
    banner: "Guided Tours – Explore with Experts",
    packages: ["Paris Walks", "Rome Guide", "London History"],
  },
  {
    title: "Transportation",
    img: scrollS3,
    rating: "4.7 (390)",
    banner: "Hop-on Hop-off City Tours",
    packages: ["NYC Big Bus", "Singapore Bus", "Dubai City Bus"],
  },
  {
    title: "Travel Services",
    img: scrollS4,
    rating: "4.7 (390)",
    banner: "Travel easy and safe with our services",
    packages: ["Insurance", "Transfers", "Guides"],
  },
  {
    title: "Cruises",
    img: scrollS5,
    rating: "4.7 (390)",
    banner: "Sail away on unforgettable journeys",
    packages: ["Caribbean", "Mediterranean", "Alaska"],
  },
].map((item) => ({
  ...item,
  id: makeSlug(item.title),
  route: `/subcategory/${makeSlug(item.title)}`, // ✅ dynamic route
}));
